/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InvoiceSortColumns {
    STAGE = 'STAGE',
    SHORT_COMPANY_NAME = 'SHORT_COMPANY_NAME',
    COUNTERPARTY_NAME = 'COUNTERPARTY_NAME',
    INVOICE_NUMBER = 'INVOICE_NUMBER',
    INVOICE_DATE = 'INVOICE_DATE',
    INVOICE_AMOUNT = 'INVOICE_AMOUNT',
    INSERTED_BY = 'INSERTED_BY',
    INSERTED_AT = 'INSERTED_AT',
    EXPENSE_TYPE = 'EXPENSE_TYPE',
    PAYMENT_STATUS = 'PAYMENT_STATUS',
    COMPANY_PAYMENT_REIMBURSEMENT_EXPENSE = 'COMPANY_PAYMENT_REIMBURSEMENT_EXPENSE',
}
